import { render, staticRenderFns } from "./TableUserApprovalConfigs.vue?vue&type=template&id=d465e38c&"
import script from "./TableUserApprovalConfigs.vue?vue&type=script&lang=js&"
export * from "./TableUserApprovalConfigs.vue?vue&type=script&lang=js&"
import style0 from "./TableUserApprovalConfigs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports